/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Plugin_Section_TitleInputs */



/**
* | output |
* | --- |
* | "AI Agent" |
*
* @param {Agent_Plugin_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_plugin_section_title = /** @type {((inputs?: Agent_Plugin_Section_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Plugin_Section_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agent IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Agent")
	if (locale === "it") return /** @type {LocalizedString} */ ("Agente IA")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ИИ-агент")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agente de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI 智能体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AI エージェント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AI एजेंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Agente de IA")
	return /** @type {LocalizedString} */ ("AI Agent")
});